module.exports = __webpack_public_path__ + "img/Black-and-black.2516c6b6.svg";